import { useState } from 'react'
import DateFormatView from '../../../../itrust_common/components/others/DateFormatView'
import { getShortName, timeFormat } from '../../../../itrust_common/components/HelperFunctions'
import NoteForm from '../../../../itrust_common/components/others/NoteForm'
import { connect } from 'react-redux'

function PrescriptionNotes(props) {
  const { prescription, PrescriptionFormData, handlePrescriptionUpdate, userId } = props
  const [showAddNoteModule, setShowAddNoteModule] = useState(false)
  const staffId = prescription.other_details?.staff_id ?? userId

  const handleNoteUpdate = async (data) => {
    if (data.notes_attributes._destroy) {
      await handlePrescriptionUpdate({ ...PrescriptionFormData, ...data })
    }
    else {
      if (data.notes_attributes.note) {
        let note = { notes_attributes: [{ ...data.notes_attributes, staff_id: staffId }] };
        data = { ...note };
        await handlePrescriptionUpdate({ ...PrescriptionFormData, ...data })
      }
    }
    setShowAddNoteModule(false)
  }

  const AddNewPrescription = () => {
    return (
      <>
        <div className='col-6'>
          <NoteForm
            onSubmit={handleNoteUpdate}
            fieldName="notes_attributes[note]"
            wrapperClasses="d-flex"
            textareaWrapperClasses="w-100"
            buttonClasses="mt-6 ml-3"
            rows={3}
          />
        </div>
        <div className='col-1'></div>
        <div className='col-2'>
          {renderAddCloseNoteBtn()}
        </div>
      </>
    )
  }

  const ListPrescriptionNotes = () => {
    return (
      <>
        <div className='col-7'>
          <h6>Notes:</h6>
          <div className='overflow-auto height-10 border rounded p-2 mt-3'>
            {prescription.notes_attributes.length !== 0 ?
              <>
                {prescription.notes_attributes.map((note, index) => <>
                  <div key={`notes-${note.id}`} className="d-flex flex-row align-items-start border-bottom border-bottom-2 border-light px-5 py-3 w-100">
                    <div className="d-flex flex-row align-items-center justify-content-between border-right border-light">
                      {getShortName(note.staff_attributes, 'width-3 height-3', 'width-3 height-3 font-size-18 ')}
                      <span className="mx-3">
                        {note.staff_attributes.name}
                        <br />
                        <small className="text-muted text-nowrap pr-3">
                          {timeFormat(note.created_at)} | <DateFormatView date={note.created_at} />
                        </small>
                      </span>
                    </div>
                    <span className="mx-3 pt-3 w-100">{note.note}</span>
                    <span className="mx-3 pt-3 w-100 text-danger pointer" onClick={() => handleNoteUpdate({ notes_attributes: { id: note.id, _destroy: true } })}>
                      Delete
                    </span>
                  </div>
                </>)}
              </> :
              <div className="text-center px-5 py-4 w-100">
                <span className="mx-3 pt-3 w-100">No Note Found</span>
              </div>
            }
          </div>
        </div>
        <div className='col-2'>
          {renderAddCloseNoteBtn()}
        </div>
      </>
    )
  }

  const renderAddCloseNoteBtn = () => {
    return (
      <>
        {showAddNoteModule ?
          <button className='btn btn-outline-primary text-nowrap' onClick={() => setShowAddNoteModule(false)}>View Notes</button> :
          <button className='btn btn-outline-primary text-nowrap' onClick={() => setShowAddNoteModule(true)}>Add New Note</button>
        }
      </>
    )
  }

  return (
    <>
      {(prescription.notes_attributes.length == 0 || showAddNoteModule) ? <AddNewPrescription /> : <ListPrescriptionNotes />}
    </>
  )
}

const mapStateToProps = (state) => {
  const { form: { PrescriptionForm } } = state

  return {
    PrescriptionFormData: PrescriptionForm?.values || {}
  }
}

export default connect(mapStateToProps)(PrescriptionNotes);